declare global {
  interface Number {
    pad(size: number): string;
  }
}

export class NumberAugmentation {
  static init() {
    Number.prototype.pad = function (size: number) {
      let strValue = String(this);
      while (strValue.length < (size || 2)) {
        strValue = '0' + strValue;
      }
      return strValue;
    };
  }
}
